<div class="flex items-center" mat-dialog-title>
  <h2 class="headline m-0 flex-auto">
    {{ title }}
  </h2>

  <button
    aria-label="close"
    class="text-secondary"
    mat-dialog-close
    mat-icon-button
    type="button">
    <mat-icon svgIcon="mat:close"></mat-icon>
  </button>
</div>

<mat-divider class="text-border"></mat-divider>

<mat-dialog-content>
  <app-common-table
    #cnTable
    [title]="title"
    [actions]="actions"
    [columns]="columns"
    [showAddButton]="false"
    [enablePadding]="false"
    (onLoadItemsEvent)="onLoadItemsEvent($event)"
    (onActionClickEmit)="onActionClickEmit($event)"
    (onBtnActionClick)="onBtnActionClick($event)"
    [childActiveRoute]="'brandFormulationHistory'">
  </app-common-table>
</mat-dialog-content>

<mat-dialog-actions class="flex flex-row justify-end"> </mat-dialog-actions>
